import React from 'react';
import { Block } from 'baseui/block';
import { SIZE, Spinner } from 'baseui/spinner';
const LOADING_MSG = 'Loading';
const Loader = ({
  hideLabel = false,
  loadingMessage = LOADING_MSG,
  size = SIZE.large
}: {
  hideLabel?: boolean;
  loadingMessage?: string;
  size?: string;
}) => {
  return <>
      <Spinner $size={size} />
      {!hideLabel ? <Block as="h5">{loadingMessage}</Block> : null}
    </>;
};
export default Loader;